import { Component, Input } from '@angular/core';
import { MatrixSummary } from '../../raport-activitate-detaliat.interface';

@Component({
    selector: 'app-matrix-summary-widgets',
    templateUrl: './matrix-summary-widgets.component.html',
    styleUrls: ['./matrix-summary-widgets.component.scss'],
})
export class MatrixSummaryWidgetsComponent {
    @Input() summary: MatrixSummary | null = null;
}
